module.exports = __webpack_public_path__ + "static/media/Hackton-logo.abc2cf19.png";